import gql from 'graphql-tag';

export const USER_LOGIN_QUERY = gql`
  query UserLoginQuery {
    userLogin {
      greetingsText
      icons {
        media {
          name
          url
          alternativeText
        }
      }
      buttons {
        label
        alt
        url
      }
    }
  }
`;

export default USER_LOGIN_QUERY;
